import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'

@Injectable({
  providedIn: 'root'
})
export class VismaService {
  constructor(private http: HttpClient) { }
  getConfig(params) {
    return this.http.get('/admin/_/service/com.storeshop.app/config', { params })
  }
  getToken(params) {
    return this.http.get('/admin/_/service/com.storeshop.app/token', { params })
  }
}
